module.exports = __webpack_public_path__ + "static/media/DSC_0437.9772cffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0437.jpg
// module id = 697
// module chunks = 0